import { PAGE_URLS, PARENT_ROUTES } from 'helpers/endpoints';
import tr from '../i18n/locales/tr';

/* eslint-disable import/no-anonymous-default-export */
export default {
  name: 'dashboard',
  component: require('layouts/Dashboard').default,
  routes: [
    {
      path: PAGE_URLS.DASHBOARD,
      name: 'dashboard',
      icon: require('@ant-design/icons/DashboardOutlined').default,
      component: require('views/Dashboard/MainDashboard/index').default,
    },
    {
      path: `${PAGE_URLS.PERFORMANCE_INFO}/:key`,
      name: 'performanceInfo',
      component: require('views/Dashboard/MainDashboard/PerformanceCardInfo').default,
      menu: false,
    },
    {
      path: PARENT_ROUTES.LIVE_TRACKING,
      name: 'liveTracking',
      icon: require('@ant-design/icons/StarOutlined').default,
      routes: [
        {
          path: PAGE_URLS.COURIER_PERFORMANCE_DASHBOARD,
          name: 'courierPerformanceDashboard',
          component:
            require('views/Dashboard/LiveTracking/CourierPerformanceDashboard')
              .default,
        },
        {
          path: PAGE_URLS.LIVE_SCREEN,
          name: 'liveScreen',
          component: require('views/Dashboard/LiveTracking/LiveScreen').default,
        },
      ],
    },
    {
      path: PARENT_ROUTES.VEHICLE_MANAGEMENT,
      name: 'fleetManagement',
      icon: require('@ant-design/icons/CarOutlined').default,
      routes: [
        {
          path: PAGE_URLS.VEHICLES,
          name: 'vehicles',
          component: require('views/Dashboard/FleetManagement/Vehicles/index')
            .default,
        },
        {
          path: PAGE_URLS.VEHICLE_GROUPS,
          name: 'vehicleGroups',
          component:
            require('views/Dashboard/FleetManagement/VehicleGroups/index')
              .default,
        },
        {
          path: PAGE_URLS.COURIERS,
          name: 'couriers',
          component: require('views/Dashboard/FleetManagement/Couriers/index')
            .default,
        },
        {
          path: PAGE_URLS.COURIERS_AWAITING_APPROVAL,
          name: 'couriersAwaitingApproval',
          component: require('views/Dashboard/FleetManagement/CouriersAwaitingApproval/index')
            .default,
        },
        {
          path: PAGE_URLS.COURIER_APPLICATIONS,
          name: 'courierApplicationList',
          component: require('views/Dashboard/FleetManagement/CourierApplications/index')
            .default,
        },
      ],
    },
    {
      path: PARENT_ROUTES.ORDER_MANAGEMENT,
      name: 'orderManagement',
      icon: require('@ant-design/icons/ShoppingOutlined').default,
      routes: [
        {
          path: PAGE_URLS.ORDERS,
          name: 'orders',
          component: require('views/Dashboard/OrderManagement/Orders').default,
        },
        {
          path: PAGE_URLS.ORDERS_PENDING_ACTIONS,
          name: 'ordersPendingAction',
          component: require('views/Dashboard/OrderManagement/OrdersPendingAction').default,
        },
        {
          path: PAGE_URLS.ORDERS_WAITING_TRANSFER,
          name: 'ordersWaitingTransfer',
          component: require('views/Dashboard/OrderManagement/OrdersWaitingTransfer').default,
        },
        {
          path: PAGE_URLS.ORDER_MAP_ANALYSIS,
          name: 'orderMapAnalysis',
          component: require('views/Dashboard/OrderManagement/OrderAnalysis').default,
        },
        {
          path: PAGE_URLS.ORDER_COURIER_MANAGEMENT,
          name: 'storeCourierSourceResource',
          component: require('views/Dashboard/OrderManagement/OrderCourierManagement').default,
        },
      ],
    },
    {
      path: PARENT_ROUTES.PRODUCT_MANAGEMENT,
      name: 'productManagement',
      icon: require('@ant-design/icons/ReconciliationOutlined').default,
      routes: [
        {
          path: PAGE_URLS.ORDER_ITEM_PROPERTIES,
          name: 'orderItemProperties',
          component:
            require('views/Dashboard/ProductManagement/GrammageProducts')
              .default,
        },
        {
          path: PAGE_URLS.PARTIAL_DELIVERY_APPROVAL,
          name: 'partialDeliveryApproval',
          component:
            require('views/Dashboard/ProductManagement/PartialDeliveryApproval')
              .default,
        },
        {
          path: PAGE_URLS.CANCELLED_ITEM_HISTORY_CONTROL,
          name: 'cancelledItemHistory',
          component:
            require('views/Dashboard/ProductManagement/CancelledItemHistory')
              .default,
        },
      ],
    },
    {
      path: PARENT_ROUTES.DEFINITIONS,
      name: 'definitions',
      icon: require('@ant-design/icons/BorderlessTableOutlined').default,
      routes: [
        {
          path: PAGE_URLS.USERS,
          name: 'users',
          component: require('views/Dashboard/Definitions/Users/index').default,
          menu: true,
        },
        {
          path: PAGE_URLS.FIRMS,
          name: 'firms',
          component: require('views/Dashboard/Definitions/Firms/index').default,
          menu: true,
        },
        {
          path: PAGE_URLS.REGIONS,
          name: 'regions',
          component: require('views/Dashboard/Definitions/Regions/index')
            .default,
          menu: true,
        },
        {
          path: PAGE_URLS.BULK_DEFINITION_TRACING,
          name: 'bulkDefinitionTracing',
          component:
            require('views/Dashboard/Definitions/BulkDefinitionTracing/index')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.MASS_INFORMATION,
          name: 'massNotification',
          component:
            require('views/Dashboard/Definitions/MassNotification/index')
              .default,
          menu: true,
        },
      ],
    },
    {
      path: PARENT_ROUTES.STORE_MANAGEMENT,
      name: 'storeManagement',
      icon: require('@ant-design/icons/ShopOutlined').default,
      routes: [
        {
          path: PAGE_URLS.STORES,
          name: 'stores',
          component: require('views/Dashboard/StoreManagement/Stores/index')
            .default,
          menu: true,
        },
        {
          path: PAGE_URLS.STORE_GROUPS,
          name: 'storeGroups',
          component:
            require('views/Dashboard/StoreManagement/StoreGroups/index')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.STORE_BASED_SECTION_SORT,
          name: 'storeBasedSectionSort',
          component:
            require('views/Dashboard/StoreManagement/StoreBasedSectionSorting/index')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.WAITING_APPROVE_STORES,
          name: 'waitingApproveStores',
          component:
            require('views/Dashboard/StoreManagement/WaitingApproveStores/index')
              .default,
          menu: true,
        },
      ],
    },
    {
      path: PARENT_ROUTES.ZONE_MANAGEMENT,
      name: 'zoneManagement',
      icon: require('@ant-design/icons/GatewayOutlined').default,
      routes: [
        {
          path: PAGE_URLS.ZONES,
          name: 'zones',
          component: require('views/Dashboard/ZoneManagement').default,
        },
        {
          path: PAGE_URLS.ZONE_UPDATE,
          name: 'bulkZoneUpdate',
          component: require('views/Dashboard/ZoneManagement/AllZoneUpdate').default,
        },
        {
          path: PAGE_URLS.TEMPLATE_MANAGEMENT,
          name: 'templateManagement',
          component:
            require('views/Dashboard/SlotManagement/TemplateManagement')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.TEMPLATE_ZONE_MATCHING,
          name: 'templateZoneMatching',
          component:
            require('views/Dashboard/SlotManagement/TemplateZoneMatching')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.SLOT_MONITORING,
          name: 'slotMonitoring',
          component: require('views/Dashboard/SlotManagement/SlotMonitoring')
            .default,
          menu: true,
        },
        {
          path: PAGE_URLS.SLOT_UPDATE,
          name: 'bulkSlotUpdateDisabled',
          component: require('views/Dashboard/SlotManagement/AllSlotUpdate').default,
        },        
      ],
    },
    {
      path: PARENT_ROUTES.REPORTS,
      name: 'reports',
      icon: require('@ant-design/icons/RiseOutlined').default,
      routes: [
        {
          path: PAGE_URLS.END_OF_DAY_REPORT,
          name: 'endOfDayReport',
          component:
            require('views/Dashboard/Reports/EndOfDayReport/EndOfDayReport')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.COURIER_SHIFT_REPORT,
          name: 'courierShiftReport',
          component: require('views/Dashboard/Reports/CourierShiftReport/index')
            .default,
          menu: true,
        },
        {
          path: PAGE_URLS.COURIER_DISTANCE_REPORT,
          name: 'courierDistanceReport',
          component:
            require('views/Dashboard/Reports/CourierDistanceReport/index')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.ORDER_STATUS_REPORT,
          name: 'orderStatusReport',
          component: require('views/Dashboard/Reports/OrderStatusReport/index')
            .default,
          menu: true,
        },
      ],
    },
    {
      path: PARENT_ROUTES.PARAMETERS,
      name: 'parameters',
      icon: require('@ant-design/icons/BarsOutlined').default,
      routes: [
        {
          path: PAGE_URLS.PARAMETER_SETTINGS,
          name: 'parameterSettings',
          component: require('views/Dashboard/Parameters').default,
        },
        {
          path: PAGE_URLS.PARAMETER_DETAIL,
          name: 'parameterSettings',
          menu: false,
          component: require('views/Dashboard/Parameters/DetailParameters').default,
        },
      ],
    },
    {
      path: PARENT_ROUTES.ROUTING_MANAGEMENT,
      name: 'routingManagement',
      icon: require('@ant-design/icons/BranchesOutlined').default,
      menu: false,
      routes: [
        {
          path: PAGE_URLS.ROUTING_PLANNING,
          name: 'routingPlanning',
          component:
            require('views/Dashboard/RoutingManagement/RoutingPlanning')
              .default,
          menu: false,
        },
        {
          path: PAGE_URLS.ROUTING_VİEW,
          name: 'routingViewList',
          component:
            require('views/Dashboard/RoutingManagement/RoutingViewList')
              .default,
          menu: false,
        },
        {
          path: PAGE_URLS.ROUTING_DETAIL,
          name: 'routingDetail',
          component: require('views/Dashboard/RoutingManagement/RoutingDetail')
            .default,
          menu: false,
        },
      ],
    },
    {
      path: PARENT_ROUTES.PROGRESS_PAYMENT_SYSTEM,
      name: 'progressPaymentSystem',
      icon: require('@ant-design/icons/DollarOutlined').default,
      routes: [
        {
          path: PAGE_URLS.PROGRESS_PAYMENT_TEMPLATES,
          name: 'progressPaymentTemplates',
          component:
            require('views/Dashboard/ProgressPayment/ProgressPaymentTemplates')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.PROGRESS_PAYMENT_STATUS_TRACKING,
          name: 'progressPaymentStatusTracking',
          component:
            require('views/Dashboard/ProgressPayment/ProgressPaymentStatusTracking')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.PROGRESS_PAYMENT_TEMPLATE_BY_STORE,
          name: 'progressPaymentTemplateByStore',
          component:
            require('views/Dashboard/ProgressPayment/ProgressPaymentTemplateByStore')
              .default,
          menu: true,
        },
      ],
    },
    {
      path: PARENT_ROUTES.STOCK_MANAGEMENT,
      name: 'stockManagement',
      icon: require('@ant-design/icons/StockOutlined').default,
      routes: [
        {
          path: PAGE_URLS.STOCK_SCREEN,
          name: 'stockTrackingScreen',
          component:
            require('views/Dashboard/StockManagement/StockTracking/index')
              .default,
          menu: true,
        },
        {
          path: PAGE_URLS.STOCK_TRANSACTION_SCREEN,
          name: 'stockTransactions',
          component:
            require('views/Dashboard/StockManagement/StockTransactions/index')
              .default,
          menu: true,
        },
      ],
    },
    {
      path: PAGE_URLS.AUTH,
      name: 'authorizationManagement',
      menu: false,
      routes: [
        {
          path: PAGE_URLS.CONTROL,
          name: 'notAuthenticationScreen',
          menu: false,
          component: require('views/Auth/Authorized').default,
        },
      ],
    },
    {
      path: PARENT_ROUTES.STORE_TASK,
      name: 'storeTask',
      icon: require('@ant-design/icons/ScheduleOutlined').default,
      routes: [
        {
          path: PAGE_URLS.STORE_TASK_PLAN,
          name: 'storeTaskTemplate',
          component: require('views/Dashboard/StoreTask/TaskPlan').default,     
        },
        {
          path: PAGE_URLS.STORE_TASK_GROUP,
          name: 'storeTaskTemplate',
          menu: false,
          component: require('views/Dashboard/StoreTask/TaskGroup').default,   
        },
        {
          path: PAGE_URLS.STORE_TASK_TEMPLATES,
          name: 'storeTaskTemplate',
          menu: false,
          component: require('views/Dashboard/StoreTask/TaskTemplates').default,   
        },
      ]
    },
    {
      path: PAGE_URLS.SETTINGS,
      name: 'settings',
      menu: false,
      routes: [
        {
          path: PAGE_URLS.MY_PROFILE,
          name: 'myProfile',
          menu: false,
          component: require('views/Dashboard/Settings/MyProfile').default,
        },
      ],
    },
  ],
};
